<div class="m-6">
  <h1 data-cy="test-registration-page-title">Test Registration</h1>
  <div>
    <app-spinner *ngIf="(registrationTestPatientsState$ | async)?.isLoading"></app-spinner>
    <div
      *ngIf="
        (registrationTestPatientsState$ | async)?.isLoading !== true && (registrationTestPatientsState$ | async)?.error
      "
    >
      <app-page-error [error]="(registrationTestPatientsState$ | async)?.error"></app-page-error>
    </div>
    <div
      *ngIf="
        (registrationTestPatientsState$ | async)?.isLoading !== true && !(registrationTestPatientsState$ | async)?.error
      "
    >
      <p-table [value]="(registrationTestPatientsState$ | async)?.data || []">
        <ng-template pTemplate="header">
          <tr>
            <th data-cy="registration-header-id">Id</th>
            <th data-cy="registration-header-first-name">First Name</th>
            <th data-cy="registration-header-last-name">Last Name</th>
            <th data-cy="registration-header-insurance-number">Insurance Number</th>
            <th data-cy="registration-header-dob">DoB</th>
            <th data-cy="registration-header-zip-code">Zip Code</th>
            <th data-cy="registration-header-update-email">Update Email</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" let-patient>
          <tr>
            <td data-cy="registration-patient-id">
              <span class="p-column-title" data-cy="registration-header-id">Id</span>{{ patient.patientId }}
            </td>
            <td data-cy="registration-patient-first-name">
              <span class="p-column-title" data-cy="registration-header-first-name">First Name</span
              >{{ patient.firstName }}
            </td>
            <td data-cy="registration-patient-last-name">
              <span class="p-column-title" data-cy="registration-header-last-name">Last Name</span
              >{{ patient.lastName }}
            </td>
            <td data-cy="registration-patient-insurance-number">
              <span class="p-column-title" data-cy="registration-header-insurance-number">Insurance Number</span
              >{{ patient.insuranceNumber }}
            </td>
            <td data-cy="registration-patient-dob">
              <span class="p-column-title" data-cy="registration-header-dob">DoB</span>{{ patient.dob | formatDate }}
            </td>
            <td data-cy="registration-patient-zip-code">
              <span class="p-column-title" data-cy="registration-header-zip-code">Zip Code</span>{{ patient.zipCode }}
            </td>
            <td data-cy="registration-patient-update-email">
              <span class="p-column-title" data-cy="registration-header-update-email">Update Email</span>
              <div *ngIf="emailsForm" class="vertical-align-middle">
                <div class="flex align-items-center">
                  <app-form-field
                    [control]="asFormControl(emailsForm!.controls[i].get('email'))"
                    [name]="'Email-' + i"
                    errorLabel="Email"
                    placeholder="Update Email"
                    [noMargin]="true"
                    class="flex-1"
                    type="input"
                    autocomplete="off"
                  ></app-form-field>
                  <button
                    pButton
                    class="button p-button-sm p-button-rounded ml-4"
                    type="button"
                    (click)="updateRegistrationTestPatient(patient.patientId)"
                    [disabled]="patient.isUpdating"
                    data-cy="update-email-button"
                  >
                    Submit
                  </button>
                </div>
                <!-- updatesLookup[patient.patientId.toString()] || '' -->
                <div class="p4 mt-2 mb-0">
                  <span *ngIf="patient.isUpdating">Updating email...</span>
                  <span *ngIf="patient.error">Error updating email</span>
                  <span *ngIf="patient.isFinished && !patient.error">Email updated to: {{ patient.data.email }}</span>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
